import component from './PhPaintBrushBroad.vue_vue_type_script_lang.vue.js';
export { default } from './PhPaintBrushBroad.vue_vue_type_script_lang.vue.js';
import { render } from './PhPaintBrushBroad.vue_vue_type_template_id_95cd9b56_lang.vue.js';

component.render = render;
